import { styled, StyledFlex } from '@raskrask-dk/rr-components'

export const StyledPaymentOverview = styled('div', {
    display: 'grid',
    gap: 8,

    [`& ${StyledFlex}`]: {
        justifyContent: 'space-between',
    },
})

export const StyledDiscount = styled('div', {
    color: '$danger',
})
